export { useScrollToId }

const SCROLL_MARGIN = 32

const useScrollToId = () => {
  const scrollToId = (id: string, offset: number = SCROLL_MARGIN) => {
    const element = document.getElementById(id)

    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY - offset

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })
    }
  }

  return { scrollToId }
}
